export const defaultFahrerMail = `<h4>Sehr geehrte Benutzerin, sehr geehrter Benutzer eines Dienstfahrzeugs,</h4>
				<p/>
				<p>an Bord Ihres Fahrzeugs befinden sich Elemente zur Ladungssicherung.<br/>
				Bitte informieren Sie sich, wie das die Unfallverhütungsvorschriften vorsehen,
	mit dem kurzweiligen Videoclip unter der folgenden Adresse, und beantworten
	Sie die anschließenden Fragen. Danke für Ihre Mitarbeit!</p>
				<p><i>Ihre Fuhrparkleitung</i></p>`

export const FSKErinnerungsmail_1 = `<h4>Sehr geehrte Fahrerin, sehr geehrter Fahrer in unserem Unternehmen,</h4>
				<p/>
				<p>die regelmäßige Kontrolle Ihres Führerscheins ist fällig.<br/>
				Bitte legen Sie Ihren Führerschein der zuständigen Person im Unternehmen vor,
				oder laden Sie die App 'Führerscheinkontrolle' aus dem App Store bzw. Play Store
				und scannen Sie Ihren Führerschein, falls schon der entsprechende Aufkleber vorhanden ist.</p>
				<p>Wir bitten darum, die Kontrolle innerhalb von 4 Tagen durchzuführen. Danke für Ihre Mitarbeit!</p>
				<p><i>Ihre Fuhrparkleitung</i></p>`

export const FSKErinnerungsmail_2 = `<h4>Sehr geehrte Fahrerin, sehr geehrter Fahrer in unserem Unternehmen,</h4>
				<p/>
				<p>die regelmäßige Kontrolle Ihres Führerscheins ist fällig. Sie haben dazu vor ein paar Tagen
				eine Mail bekommen.<br/>
				<p>Wir bitten darum, die Kontrolle innerhalb der nächsten 3 Tage durchzuführen. Danke für Ihre Mitarbeit!</p>
				<p><i>Ihre Fuhrparkleitung</i></p>`



// WEBPACK FOOTER //
// ./src/constants/fahrer.constants.js